export default __webpack_public_path__ + "static/media/JWF06735.00_01_12_08.Still006.36c9a5fe.jpg";